module.exports = __webpack_public_path__ + "img/cleanup3-7-8-2021.8983a683.jpg";